"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = exports.formPost = exports.axios = exports.ajaxPut = exports.ajaxPost = exports.ajaxPatch = exports.ajaxGet = exports.ajaxDelete = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios2 = _interopRequireDefault(require("axios"));

var _reduxActions = require("redux-actions");

var _reactIntercom = require("react-intercom");

var _httpActions = require("./http-actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var axios = _axios2.default.create();

exports.axios = axios;
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  try {
    if (error.response.status === 401 || error.response.status === 403 && error.response.data.message.toUpperCase() === 'UNAUTHENTICATED') {
      (0, _reactIntercom.IntercomAPI)('shutdown');
    }
  } catch (e) {// ignored
  }

  return Promise.reject(error);
});
/**
 * Default noop function that can be overridden for progress indicators
 */

var noop = function noop() {};

exports.noop = noop;

function errorHandling(error) {
  if (error.response) {
    return error.response.data;
  } else if (error.request) {
    // TODO: handle request error
    console.error("Unexpected request error ".concat(error.request), error); // eslint-disable-line no-console
  } else {
    console.error("Something happened setting up the request ".concat(error.message), error); // eslint-disable-line no-console
  }

  return null;
}

function cancelOption(dispatch, config) {
  var options = config || {}; // default params don't work for null

  var overrideCancel = options.overrideCancel;
  if (options.hasOwnProperty('overrideCancel')) delete options.overrideCancel; // eslint-disable-line no-param-reassign

  var cancellable = null;

  if (!overrideCancel) {
    cancellable = {
      cancelToken: new _axios2.default.CancelToken(function (c) {
        return dispatch((0, _reduxActions.createAction)(_httpActions.HTTP_ADD_CANCEL)(c));
      })
    };
  }

  return Object.assign({}, cancellable, options);
}

var ajaxGet = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(action, dispatch, url) {
    var config,
        meta,
        dispatchHttpActions,
        result,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            meta = _args.length > 4 && _args[4] !== undefined ? _args[4] : null;
            dispatchHttpActions = _args.length > 5 && _args[5] !== undefined ? _args[5] : true;
            if (dispatchHttpActions) dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context.prev = 5;
            _context.next = 8;
            return axios.get(url, cancelOption(dispatch, config));

          case 8:
            result = _context.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, meta);
            })(result.data));
            return _context.abrupt("return", Promise.resolve(result.data));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);

            if (_axios2.default.isCancel(_context.t0)) {
              console.warn('Request canceled', _context.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context.t0)));
            }

            return _context.abrupt("return", Promise.reject(_context.t0.response));

          case 17:
            _context.prev = 17;
            if (dispatchHttpActions) dispatch((0, _httpActions.complete)());
            return _context.finish(17);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 13, 17, 20]]);
  }));

  return function ajaxGet(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.ajaxGet = ajaxGet;

var ajaxPost = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(action, dispatch, url, data) {
    var config,
        dispatchHttpActions,
        result,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            config = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
            dispatchHttpActions = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : true;
            if (dispatchHttpActions) dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context2.prev = 4;
            _context2.next = 7;
            return axios.post(url, data, cancelOption(dispatch, config));

          case 7:
            result = _context2.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, data);
            })(result.data));
            return _context2.abrupt("return", Promise.resolve(result.data));

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](4);

            if (_axios2.default.isCancel(_context2.t0)) {
              console.warn('Request canceled', _context2.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context2.t0)));
            }

            return _context2.abrupt("return", Promise.reject(_context2.t0.response));

          case 16:
            _context2.prev = 16;
            if (dispatchHttpActions) dispatch((0, _httpActions.complete)());
            return _context2.finish(16);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 12, 16, 19]]);
  }));

  return function ajaxPost(_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

exports.ajaxPost = ajaxPost;

var ajaxPatch = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(action, dispatch, url, data) {
    var config,
        result,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            config = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : null;
            dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context3.prev = 3;
            _context3.next = 6;
            return axios.patch(url, data, cancelOption(dispatch, config));

          case 6:
            result = _context3.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, data);
            })(result.data));
            return _context3.abrupt("return", Promise.resolve(result.data));

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);

            if (_axios2.default.isCancel(_context3.t0)) {
              console.warn('Request canceled', _context3.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context3.t0)));
            }

            return _context3.abrupt("return", Promise.reject(_context3.t0.response));

          case 15:
            _context3.prev = 15;
            dispatch((0, _httpActions.complete)());
            return _context3.finish(15);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 11, 15, 18]]);
  }));

  return function ajaxPatch(_x8, _x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

exports.ajaxPatch = ajaxPatch;

var ajaxPut = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(action, dispatch, url, data) {
    var config,
        result,
        _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            config = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : null;
            dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context4.prev = 3;
            _context4.next = 6;
            return axios.put(url, data, cancelOption(dispatch, config));

          case 6:
            result = _context4.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, data);
            })(result.data));
            return _context4.abrupt("return", Promise.resolve(result.data));

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](3);

            if (_axios2.default.isCancel(_context4.t0)) {
              console.warn('Request canceled', _context4.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context4.t0)));
            }

            return _context4.abrupt("return", Promise.reject(_context4.t0.response));

          case 15:
            _context4.prev = 15;
            dispatch((0, _httpActions.complete)());
            return _context4.finish(15);

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 11, 15, 18]]);
  }));

  return function ajaxPut(_x12, _x13, _x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();

exports.ajaxPut = ajaxPut;

var ajaxDelete = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(action, dispatch, url) {
    var config,
        meta,
        result,
        _args5 = arguments;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            config = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : null;
            meta = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : null;
            dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context5.prev = 4;
            _context5.next = 7;
            return axios.delete(url, cancelOption(dispatch, config));

          case 7:
            result = _context5.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, meta);
            })(result.data));
            return _context5.abrupt("return", Promise.resolve(result.data));

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](4);

            if (_axios2.default.isCancel(_context5.t0)) {
              console.warn('Request canceled', _context5.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context5.t0)));
            }

            return _context5.abrupt("return", Promise.reject(_context5.t0.response));

          case 16:
            _context5.prev = 16;
            dispatch((0, _httpActions.complete)());
            return _context5.finish(16);

          case 19:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[4, 12, 16, 19]]);
  }));

  return function ajaxDelete(_x16, _x17, _x18) {
    return _ref5.apply(this, arguments);
  };
}();

exports.ajaxDelete = ajaxDelete;

var formPost = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(action, dispatch, url, formData) {
    var meta,
        onProgress,
        options,
        result,
        _args6 = arguments;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            meta = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : null;
            onProgress = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : noop;
            if (onProgress === noop) dispatch((0, _httpActions.request)());
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.REQUEST))());
            _context6.prev = 4;
            options = {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: onProgress
            };
            _context6.next = 8;
            return axios.post(url, formData, cancelOption(dispatch, options));

          case 8:
            result = _context6.sent;
            dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.SUCCESS), null, function () {
              return _objectSpread({}, meta);
            })(result.data));
            return _context6.abrupt("return", Promise.resolve(result.data));

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](4);

            if (_axios2.default.isCancel(_context6.t0)) {
              console.warn('Request canceled', _context6.t0); // eslint-disable-line no-console
            } else {
              dispatch((0, _reduxActions.createAction)("".concat(action, "_").concat(_httpActions.FAILURE))(errorHandling(_context6.t0)));
            }

            return _context6.abrupt("return", Promise.reject(_context6.t0.response));

          case 17:
            _context6.prev = 17;
            if (onProgress === noop) dispatch((0, _httpActions.complete)());
            return _context6.finish(17);

          case 20:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 13, 17, 20]]);
  }));

  return function formPost(_x19, _x20, _x21, _x22) {
    return _ref6.apply(this, arguments);
  };
}();

exports.formPost = formPost;